// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	IntegratedIcon: 'integrated-icon',
	HomeIcon: 'home-icon',
	MapIcon: 'map-icon',
	CityIcon: 'city-icon',
	PartiesIcon: 'parties-icon',
	PartiesIcon1: 'parties-icon-1',
	RefreshIcon: 'refresh-icon',
	ExclamationIcon: 'exclamation-icon',
	CheckIcon: 'check-icon',
	GoToMapDiv: 'go-to-map-div',
	GoToMapDiv1: 'go-to-map-div-1',
	OpenSimilarNamesModalDiv: 'open-similar-names-modal-div',
	GoToSyncDiv: 'go-to-sync-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
